module.exports = __webpack_public_path__ + "img/Logo_light.svg";